module.exports = __webpack_public_path__ + "static/media/sidelogo.913d0254.svg";